var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isValid, } from '../../../../kaylee/EquipmentStates';
import { assertIsSetParam, } from './EquipmentServiceDriver';
import { convertNumber } from './ParamBridge';
import { ConfigKeyedValueBridge } from './ValueBridge';
export class LightingLevelBridge extends ConfigKeyedValueBridge {
    constructor(state, rangesState, control, config, controlInfo, powerState, transport, valueCallback, log) {
        super('lightingLevel', state, control, 'lightingControls', config, controlInfo, powerState, transport, valueCallback, log);
        this.rangesState = rangesState;
        assertIsSetParam(this.name);
        this.setFilters[this.name] = this.setFilter.bind(this);
        this.rangesStateSubscription = this.rangesState.subscribe((key, prevValue) => {
            const prevLevel = prevValue === undefined
                ? undefined
                : convertNumber(this.state.values[key], prevValue.max, prevValue.min, 100, 0, 1);
            const newLevel = convertNumber(this.state.values[key], this.rangesState.values[key].max, this.rangesState.values[key].min, 100, 0, 1);
            if (newLevel !== prevLevel) {
                this.valueCallback('lightingLevel', {
                    lightingControlId: key,
                    value: newLevel,
                });
            }
        });
    }
    convertFromParam(value) {
        const fromValue = value.value;
        const dKey = this.keyMap[value.lightingControlId];
        if (dKey === undefined) {
            this.log.error(`${value.lightingControlId} not found in key map`);
            return { key: value.lightingControlId, value: 0 };
        }
        const range = this.rangesState.values[dKey];
        if (range === undefined) {
            this.log.error(`range undefined for key: ${dKey}`);
            return { key: value.lightingControlId, value: 0 };
        }
        const convertedValue = convertNumber(fromValue, 100, 0, range.max, range.min, range.round);
        return { key: value.lightingControlId, value: convertedValue };
    }
    convertToParam(key, value) {
        const dKey = this.keyMap[key];
        if (dKey === undefined) {
            this.log.error(`${key} not found in key map`);
            return { lightingControlId: key, value: 0 };
        }
        const range = this.rangesState.values[dKey];
        if (range === undefined) {
            this.log.error(`range undefined for key: ${key}`);
            return { lightingControlId: key, value: 0 };
        }
        const convertedValue = convertNumber(value, range.max, range.min, 100, 0, 1);
        return { lightingControlId: key, value: convertedValue };
    }
    destroy() {
        this.rangesState.unsubscribe(this.rangesStateSubscription);
        super.destroy();
    }
    getInfo(config) {
        return undefined;
    }
    setFilter(param, value, compParam, compValue) {
        if (param !== compParam)
            return true;
        const lightingControlId = value.lightingControlId;
        const compLightingControlId = compValue.lightingControlId;
        return lightingControlId !== compLightingControlId;
    }
    validate() {
        const _super = Object.create(null, {
            validate: { get: () => super.validate }
        });
        return __awaiter(this, void 0, void 0, function* () {
            // Call super's validate first because it calls buildKeyMap(), and we need those results.
            const validated = yield _super.validate.call(this);
            // Get the ranges for each control.
            if (isValid(validated)) {
                const rc = this.control;
                for (const eKey of Object.keys(this.config)) {
                    const dKey = this.keyMap[eKey];
                    if (dKey === undefined) {
                        this.log.error(`${eKey} not found in key map`);
                        continue;
                    }
                    this.rangesState.values[dKey] =
                        typeof rc.range === 'function'
                            ? yield rc.range(this.config[eKey], undefined)
                            : rc.range;
                }
            }
            return validated;
        });
    }
}
export class LightingPowerBridge extends ConfigKeyedValueBridge {
    constructor(state, control, config, controlInfo, powerState, transport, valueCallback, log) {
        super('lightingPower', state, control, 'lightingControls', config, controlInfo, powerState, transport, valueCallback, log);
        assertIsSetParam(this.name);
        this.setFilters[this.name] = this.setFilter.bind(this);
    }
    convertFromParam(value) {
        return { key: value.lightingControlId, value: value.value };
    }
    convertToParam(key, value) {
        return { lightingControlId: key, value };
    }
    getInfo(config) {
        return undefined;
    }
    setFilter(param, value, compParam, compValue) {
        if (param !== compParam)
            return true;
        const lightingControlId = value.lightingControlId;
        const compLightingControlId = compValue.lightingControlId;
        return lightingControlId !== compLightingControlId;
    }
}
export class LightingPresetBridge extends ConfigKeyedValueBridge {
    constructor(state, control, config, controlInfo, powerState, transport, valueCallback, log) {
        super('lightingPreset', state, control, 'lightingPresets', config, controlInfo, powerState, transport, valueCallback, log);
        // No set filter. Run all lighting presets.
    }
    convertFromParam(value) {
        return { key: value.lightingPresetId, value: value.value };
    }
    convertToParam(key, value) {
        return { lightingPresetId: key, value };
    }
    getInfo(config) {
        return undefined;
    }
}
